import { createRouter, createWebHistory } from 'vue-router';

import CheckoutFlow from '@/views/CheckoutFlow.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import WarehouseError from '@/views/WarehouseError.vue';
import NotFoundPage from '@/views/NotFoundPage.vue';
import BolErrorPage from '@/views/BolErrorPage.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'checkout-flow',
      component: CheckoutFlow
    },
    {
      path: '/error',
      name: 'error-page',
      props: true,
      component: ErrorPage
    },
    {
      path: '/bol-error',
      name: 'bol-error',
      props: true,
      component: BolErrorPage
    },
    {
      path: '/warehouse-error',
      name: 'warehouse-error',
      props: true,
      component: WarehouseError
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFoundPage
    }
  ]
});

export default router;
